// extracted by mini-css-extract-plugin
export default {"facetSearchContainer":"facetSearchContainer---vAbNM","facetSearch":"facetSearch---q5h_M","moreIcon":"moreIcon---YsIRK"};